import { useState } from "react";
import { useSelector } from "react-redux";
import today from "../../../Artifacts/Todaysretail.png";
import OfftakeMtd from "../../../Artifacts/offtakemtd.png";
import total from "../../../Artifacts/TotalRetail.png";
import { PriKPI } from "../../../Components/KPI/PriKPI";
import { useQuery } from "@tanstack/react-query";
import { TbFilterDown } from "react-icons/tb";
import OfftakeFilter from "../../../Components/Filters/OfftakeFilter.jsx";
import { OfftakeTableDetailed } from "../OfftakeDetail/OfftakeTableDetailed.jsx";

import { mtd_offtake, today_offtake, total_offtake } from "./ApiOfftake";

export const OfftakeKpi = () => {
  const { data, submitted } = useSelector((state) => state.filtersOfftake);
  const [isFormVisible, setFormVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data: mtdOfftake } = useQuery({
    queryKey: ["mtd_offtake", submitted],
    queryFn: () => mtd_offtake(data),
    initialData: [],
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });

  const { data: todayOfftake } = useQuery({
    queryKey: ["today_offtake", submitted],
    queryFn: () => today_offtake(data),
    initialData: [],
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });

  const { data: totalOfftake } = useQuery({
    queryKey: ["total_offtake", submitted],
    queryFn: () => total_offtake(data),
    initialData: [],
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });
  const toggleForm = () => {
    setFormVisible(!isFormVisible);
  };
  const openModal = () => {
    setIsModalOpen(true);
  };

  return (
    <div className="flex flex-col gap-2 ">
      {isFormVisible && (
        <OfftakeFilter
          isFormVisible={isFormVisible}
          setFormVisible={setFormVisible}
        />
      )}
      <div className="flex gap-2  md:flex-row flex-col-reverse">
        <section className="md:grid block grid-cols-2 gap-2 md:grid-cols-3 lg:grid-cols-3 md:w-[95%] w-full">
          <PriKPI
            Image={today}
            Alt={"Today’s Offtake"}
            ColorDark={"bg-gradient-to-b from-[#FFE700] to-[#F9A526]"}
            Title={"Today’s Offtake"}
            Value={todayOfftake || 0}
            Padding={"p-2 md:mt-0 sm:mt-5"}
            ImageSize={"w-12 h-12"}
          />

          <PriKPI
            Image={OfftakeMtd}
            Alt={"MTD Offtake"}
            ColorDark={"bg-gradient-to-b from-[#3CD0C0] to-[#129BD2]"}
            Title={"MTD Offtake"}
            Value={mtdOfftake || 0}
            Padding={"p-2 md:mt-0 sm:mt-5"}
            ImageSize={"w-12 h-12"}
          />

          <PriKPI
            Image={total}
            Alt={"Total Offtake"}
            ColorDark={"bg-gradient-to-b from-[#EF6AE9] to-[#8463FA]"}
            Title={"Total Offtake"}
            Value={totalOfftake || 0}
            Padding={"p-2 md:mt-0 sm:mt-5"}
            ImageSize={"w-14 h-12"}
            onclick={openModal}
            title={"Click to View Detailed Summary"}
            handPosition={" right-[15px] top-[17px] "}
          />
        </section>
        <div
          className="w-full lg:w-[5%] rounded-lg p-2 bg-gradient-to-b from-rose-300 to-orange-200 flex justify-center items-center transition duration-300 ease-in-out transform hover:scale-105 cursor-pointer "
          onClick={toggleForm}
        >
          <button title="Click to Apply Filters">
            <TbFilterDown className="w-7 h-7 text-[#2A5775]" />
          </button>
        </div>
      </div>
      {isModalOpen && (
        <OfftakeTableDetailed closeModal={() => setIsModalOpen(false)} />
      )}
    </div>
  );
};
